 <template>
  <div>  <div class="seachBox flex">
    <div class="seachList"><span class="name">来源客户：</span>
      <a-input placeholder="" class="seachs" v-model="seach.customer"/>
    </div>

    <div class="seachList"><span class="name">填写日期：</span>
      <a-range-picker class="seachs" v-model="seach.create_time" :allowClear="false" :showTime="false"
                      format="YYYY-MM-DD"/>
    </div>
    <div class="seachList"><span class="name">关键字：</span>
      <a-input placeholder="联系人/手机/公司名称" class="seachs" v-model="seach.keyword"/>
    </div>
    <div class="seachList"><span class="name">状态：</span>
      <a-select v-model="seach.status" class="seachs" allowClear placeholder="请选择"  >
        <a-select-option :value="item.value" :key="index" v-for="(item,index) in status">
          {{item.name}}
        </a-select-option>
      </a-select>
    </div>
    <div class="seachBtnBox  ">
      <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
        查询
      </a-button>
      <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button>
    </div>
    <div class="seachList no"></div>
    <div class="seachList no"></div>
  </div>
<!--    :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"  ,y:500-->
    <a-button class="top_btn" type="primary" @click=" exper">
      导出
    </a-button>


    <a-table :columns="columns" :data-source="datas"  :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"    :pagination="pagination" rowKey="id"  :scroll="{ x: 1300}"
            >

      <a slot="customer_name" slot-scope="text, record">
        <router-link :to="{ path:'/CustomerPoints/CustomerPointsDetails', query:{id:record.a_customer_id}}">{{text}} </router-link>
      </a>
      <span slot="statuss" slot-scope="text, record" >
{{filterStatus(text)}}
      </span>
      <span slot="status" slot-scope="text, record" >
        <a-button v-show="record.status==0" @click="chackStatus(record.id,record.a_customer_id,record.status+1,'确定要审核通过吗？')" type="link"> 审核 </a-button>
        <a-button v-show="record.status==1" @click="chackStatus(record.id,record.a_customer_id,record.status+1,'确定已成单吗？')" type="link"> 成单 </a-button>
        <span v-if="record.status==2">已成单</span>
      </span>

    </a-table>


    <a-modal
        title="确认"
        v-model="visible"
        width="350px"
        @cancel="()=>{visible=true}"
        :closable="true"
    >
      <template #footer>
        <a-button key="submit" type="primary" :loading="loading" @click="modalChackStatus('',1)">{{modal.status==2?"确定":"通过"}}</a-button>
        <a-button key="back" @click="modalChackStatus('',2)">{{modal.status==2?"取消":"拒绝"}}</a-button>
      </template>
      <p>{{modal.text}}</p>
    </a-modal>
  </div>
</template>

<script>
import API from "./api/index"
import moment from "moment"
const columns = [
  {
    title: "联系人",
    dataIndex: "name",
    key: "name",
    width: "150px",
    ellipsis: true,
  },
  {
    title: "手机",
    dataIndex: "mobile",
    ellipsis: true,
    width: "150px",
    key: "mobile",
  },

  {
    title: "公司名称",
    dataIndex: "company",
    ellipsis: true,
    width: "150px",
    key: "company",
    scopedSlots: {customRender: "company"}
  },
  {
    title: "qq",
    key: "qq",
    dataIndex: "qq",
    width: "150px",
    scopedSlots: {customRender: "qq"}
  },
  {
    title: "微信",
    key: "wechat",
    dataIndex: "wechat",
    width: "150px",
    scopedSlots: {customRender: "wechat"}
  },
  {
    title: "行业",
    key: "industry",
    dataIndex: "industry",
    width: "150px",
    scopedSlots: {customRender: "industry"}
  },
  {
    title: "咨询内容",
    key: "content",
    dataIndex: "content",
    width: "150px",
    scopedSlots: {customRender: "content"}
  },
  {
    title: "来源客户",
    key: "customer_name",
    dataIndex: "customer_name",
    width: "150px",
    scopedSlots: {customRender: "customer_name"}
  },
  {
    title: "填写日期",
    key: "create_time",
    dataIndex: "create_time",
    width: "150px",
    scopedSlots: {customRender: "create_time"}
  },
  {
    title: "状态",
    key: "status",
    dataIndex: "status",
    width: "150px",
    scopedSlots: {customRender: "statuss"}
  },
  {
    title: "操作",
    key: "status",
    dataIndex: "status",
    width: "150px",
    scopedSlots: {customRender: "status"}
  },

];
export default {
  name: "index",
  data(){
    return{
      seach: {
        customer: "",
        create_time:[],
        keyword: "",
        status:undefined
      },
      status:[],
      exportData:{},
      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true
      },
      datas: [],
      columns:columns,
      selectedRowKeys: [], // Check here to configure the default column
      loading: true,
      visible:false,
      modal:{
        text:"",
        okText:"",
        cancelText:"",
        status:"",
        a_customer_id:"",
        id:""
      }
    }
  },
  created() {
    this.$store.state.adminleftnavnum = "/DataStatistics/ProductArticle"; //设置左侧导航2-2 active
  },

  mounted() {
    this.getList()
  },

  methods:{
    modalChackStatus(modal,type){
      let _this=this
      modal=_this.modal
      if(type==1){
        API.service.AUDIT({id:modal.id,a_customer_id:modal.a_customer_id,status:modal.status}).then(res => {
          if(res.data.code==200){
            _this.$message.success(res.data.msg,1.5)
          }
          _this.getList()
          _this.visible=false
        })

      }else{
        if(modal.status==1){
          // alert(status)
          API.service.AUDIT({id:modal.id,a_customer_id:modal.a_customer_id,status:3}).then(res => {
            if(res.data.code==200){
              _this.$message.success(res.data.msg,1.5)
            }
            _this.getList()
            _this.visible=false
          })
        }else{
          _this.visible=false
        }

      }
    },
    chackStatus(id,a_customer_id,status,text){
      let _this=this
      _this.visible=true
      _this.modal={
            text:text,
            okText:status==2?"确定":"通过",
            cancelText:status==2?"取消":"拒绝",
            status:status,
            a_customer_id:a_customer_id,
            id:id
      }

    },
    exper(id) {
      API.service.EXPORT({...this.exportData,ids:this.selectedRowKeys}).then(res => {
        window.open(`${this.$store.state.urlExper}${res.data.data.path.substr(1)}`)
        // this.getList()
        // this.selectedRowKeys = []
      })
    },
    resetSeach() {
      this.loading = true
      this.seach = {
        customer: "",
        create_time:[],
        keyword: "",
      }
      this.getList(1)
    },
    getList(page) {
      let seachData = JSON.parse(JSON.stringify(this.seach))
      if (seachData.create_time.length > 0 ) {
        seachData.create_time[0] = moment(seachData.create_time[0]).format('YYYY-MM-DD')
        seachData.create_time[1] = moment(seachData.create_time[1]).format('YYYY-MM-DD')
      }else{
        seachData.create_time=[]
      }
      API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
        this.datas = res.data.data.list.data
        this.pagination.total = res.data.data.list.total
        this.pagination.pageSize = res.data.data.list.per_page
        this.pagination.current = res.data.data.list.current_page
        this.selectedRowKeys=[]
        this.status=res.data.data.status
        this.loading = false
      })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
    filterStatus() {
      return function(type){
        switch (type) {
          case 0:
            return "待审核";
            break;
          case 1:
            return "已审核"
            break;
          case 2:
            return "已成单"
            break;
          case 3:
            return "已拒绝"
            break;
        }

      }
    }
  },
}
</script>

<style scoped>
.seachBox .seachList .name {
  width: 70px !important;
}

.seachBox .seachList .seachs {
  width: calc(100% - 80px);
}

.inputs {
  display: inline-block;
  width: 70px
}
.num_input{width:30%}
.chackStatusConfirm>>>.ant-modal-confirm-btns .ant-btn ant-btn-primary{float: left!important;margin-right: 10px}
.ant-table-body{max-height: calc(100vh - 500px)!important;}
</style>
